import { render } from "./NewsInner.vue?vue&type=template&id=5fb1ea9b&scoped=true"
import script from "./NewsInner.vue?vue&type=script&lang=js"
export * from "./NewsInner.vue?vue&type=script&lang=js"

import "./NewsInner.vue?vue&type=style&index=0&id=5fb1ea9b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb1ea9b"]])

export default __exports__